/**
 * @description 获取当前视口的宽度，判断默认样式
 * @param {Number} size
 * @returns true<1025<=false
 */
export function checkWidth(size) {
    const width = size || window.document.body.offsetWidth;
    if (width < 1025) {
        return true;
    } else {
        return false;
    }
}

/**
 * @description 对象拷贝
 * @param {Object} obj
 * @param {Boolean} deep
 * @returns
 */
export function clone(obj, deep) {
    if (!obj) return obj;
    if (deep) return JSON.parse(JSON.stringify(obj));
    return Array.isArray(obj) ? obj.slice(0) : Object.assign({}, obj);
}

/**
 * @description 对象深拷贝
 * @param {Object} target
 * @returns
 */
export function deepClone(target) {
    // 定义一个变量
    let result;
    // 如果当前需要深拷贝的是一个对象的话
    if (typeof target === 'object') {
        // 如果是一个数组的话
        if (Array.isArray(target)) {
            result = []; // 将result赋值为一个数组，并且执行遍历
            for (let i in target) {
                // 递归克隆数组中的每一项
                result.push(deepClone(target[i]));
            }
            // 判断如果当前的值是null的话；直接赋值为null
        } else if (target === null) {
            result = null;
            // 判断如果当前的值是一个RegExp对象的话，直接赋值
        } else if (target.constructor === RegExp) {
            result = target;
        } else {
            // 否则是普通对象，直接for in循环，递归赋值对象的所有值
            result = {};
            for (let i in target) {
                result[i] = deepClone(target[i]);
            }
        }
        // 如果不是对象的话，就是基本数据类型，那么直接赋值
    } else {
        result = target;
    }
    // 返回最终结果
    return result;
}

/**
 * 异步加载 script 脚本
 * @param {string} path
 */
export function loadScript(path) {
    // 先对队列中的内容进行初始化，并检查队列，避免并发竞争出现 bug
    if (window.__loadScriptQueue === undefined) window.__loadScriptQueue = {};
    if (!Array.isArray(window.__loadScriptQueue[path])) window.__loadScriptQueue[path] = [];
    if (Array.isArray(window.__loadScriptQueue[path])
        && window.__loadScriptQueue[path].length > 0) {
        return new Promise((resolve) => {
            console.log('wq: 队列中有数据，添加到队列中。');
            window.__loadScriptQueue[path].push(resolve);
        });
    } else {
        return new Promise((resolve) => {
            let cdnUrl = ''
            if (import.meta.env.VITE_ENV_CONFIG.includes('dev') || import.meta.env.VITE_ENV_CONFIG.includes('test')) {
                cdnUrl = 'https://test-m2cdn.fastindexs.com'
            } else if (import.meta.env.VITE_ENV_CONFIG.includes('pre')) {
                cdnUrl = 'https://pre-m2cdn.fastindexs.com'
            } else if (import.meta.env.VITE_ENV_CONFIG.includes('prod')) {
                cdnUrl = 'https://m2cdn.fastindexs.com'
            }
            let __CDN_PREFIX = location.hostname == "localhost" ?  "" : cdnUrl + "/npmanager";
            // 请求如果不是以 http 或 // 开头的，需要补充 cdn 域名
            let originPath = path;
            if (!/^(http|\/\/)/isg.test(path)) {
                path = __CDN_PREFIX + path;
            }
            window.__loadScriptQueue[originPath].push(resolve);
            loadScripts(path, () => {
                for (let i = 0; i < window.__loadScriptQueue[originPath].length; i++) {
                    console.log('wq: 加载完成，遍历队列中的数据：', i, originPath);
                    window.__loadScriptQueue[originPath][i]();
                }
                window.__loadScriptQueue[originPath] = [];
            });
        });
    }
}

/**
 * 异步加载 css 脚本
 * @param {string} path
 */
export function loadCss(path) {
    return new Promise((resolve) => {
        let cdnUrl = ''
        if (import.meta.env.VITE_ENV_CONFIG.includes('dev') || import.meta.env.VITE_ENV_CONFIG.includes('test')) {
            cdnUrl = 'https://test-m2cdn.fastindexs.com'
        } else if (import.meta.env.VITE_ENV_CONFIG.includes('pre')) {
            cdnUrl = 'https://pre-m2cdn.fastindexs.com'
        } else if (import.meta.env.VITE_ENV_CONFIG.includes('prod')) {
            cdnUrl = 'https://m2cdn.fastindexs.com'
        }else{
            cdnUrl = 'https://test-m2cdn.fastindexs.com'
        }
        let __CDN_PREFIX = location.hostname == "localhost" ?  "" : cdnUrl + "/npmanager";
        // 请求如果不是以 http 或 // 开头的，需要补充 cdn 域名
        if (!/^(http|\/\/)/isg.test(path)) {
            path = __CDN_PREFIX + path;
        }
        loadCssList(path, () => {
            resolve();
        });
    });
}

/**
 * @description 加载script
 * @param {String} urls
 * @param {Function} callback
 */
export function loadScripts(urls, callback) {
    if (typeof urls === 'string') urls = [urls];
    let loaded = 0;
    urls.map(url => {
        if (document.querySelector('script[src="' + url + '"]')) {
            onScriptLoad();
        } else {
            const script = document.createElement('script');
            script.src = url;
            script.onload = onScriptLoad;
            document.querySelector('head').appendChild(script);
        }
    });
    function onScriptLoad() {
        loaded++;
        if (loaded === urls.length) {
            if (callback) callback();
        }
    }
}

/**
 * @description 加载css
 * @param {String} urls
 * @param {Function} callback
 */
export function loadCssList(urls, callback) {
    // <link rel="stylesheet" href="https://doc/css.min.css">
    if (typeof urls === 'string') urls = [urls];
    let loaded = 0;
    urls.map(url => {
        if (document.querySelector('link[href="' + url + '"]')) {
            onCssLoad();
        } else {
            const link = document.createElement('link');
            link.href = url;
            link.setAttribute("rel", "stylesheet");
            link.onload = onCssLoad;
            document.querySelector('head').appendChild(link);
        }
    });
    function onCssLoad() {
        loaded++;
        if (loaded === urls.length) {
            if (callback) callback();
        }
    }
}

/**
 * @description 频率控制 函数连续调用时，fn 执行频率限定为 1次/waitMs。立即执行
 * @param {Number} waitMs
 * @param {Function} fn
 * @returns
 */
export function throttle(waitMs, fn) {
    let lastRun = 0;
    return function () {
        const now = +new Date();
        if (now - lastRun > waitMs) {
            lastRun = now;
            fn.apply(null, arguments);
        }
    };
}

/**
 * @description 空闲控制 返回函数连续调用时，空闲时间必须大于或等于 waitMs，fn 才会执行。延迟执行
 * @param {Number} waitMs
 * @param {Function} fn
 * @returns
 */
export function debounce(waitMs, fn) {
    let lastCall, args, timeout;
    return function r() {
        lastCall = +new Date();
        args = arguments;
        if (!timeout) {
            timeout = setTimeout(later, waitMs);
        }
    };

    function later() {
        const past = +new Date() - lastCall;
        if (past > waitMs) {
            timeout = null;
            fn.apply(null, args);
        } else {
            timeout = setTimeout(later, waitMs - past + 1);
        }
    }
}

/**
 * @description 回到顶部 有问题待修改验证
 */
export function scrollToTop() {
    const cubic = value => Math.pow(value, 3);
    const easeInOutCubic = value => (value < 0.5 ? cubic(value * 2) / 2 : 1 - cubic((1 - value) * 2) / 2);
    // let el = document.documentElement;
    let el = document.querySelector('.layout-backtop .el-scrollbar__wrap');
    const beginTime = Date.now();
    const beginValue = el.scrollTop;
    const rAF = window.requestAnimationFrame || (func => setTimeout(func, 16));
    const frameFunc = () => {
        const progress = (Date.now() - beginTime) / 500;
        if (progress < 1) {
            el.scrollTop = beginValue * (1 - easeInOutCubic(progress));
            rAF(frameFunc);
        } else {
            el.scrollTop = 0;
        }
    };
    rAF(frameFunc);
}
/**
 * 为邮件图片URL添加验证参数 跳过防盗链检测
 * 此函数向给定的URL添加一个名为'vf'的查询参数，值为'B7gH3s'
 * 如果URL已经包含查询参数，则使用'&'连接新参数；否则使用'?'开始查询字符串
 * 
 * @param {string} url - 原始图片URL
 * @returns {string} 添加了验证参数的URL
 */
export function getEmailImgUrl(url) {
    return url.includes('?') ? url+'&vf=B7gH3s' : url+'?vf=B7gH3s'
}
